// System gate keys for non feature UI toggles — must match backend SystemGateKeys.php

export const FREE_TIER_UPGRADE_BANNER = "free-tier-upgrade-banner";
